import React from "react";
import {Box, Flex, Text, Button, Icon} from "@chakra-ui/react";
import {FiEye, FiX} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import {leaveDependent} from "./Dependent/leaveDependent";

// The standing reminder that the screen is about somebody else.
//
// It is not decoration. A guardian who forgets whose record is open cancels the
// wrong appointment, and a portal that looks identical in both modes invites
// exactly that. Leaving costs one click and loads nothing: the account holder's
// own data was never replaced, so there is nothing to fetch back.

export default function DependentBanner({state}) {
  const navigate = useNavigate();
  if (!state?.viewingDependent) return null;

  const identity = state?.activeDependent?.identity || {};
  const fullName = `${identity.fName || ""} ${identity.lName || ""}`.trim() || "a dependent";

  const handleExit = () => leaveDependent(navigate, state);

  return (
    <Box bg="orange.100" borderBottom="1px solid" borderColor="orange.200" px={4} py={2}>
      <Flex align="center" justify="space-between" gap={3}>
        <Flex align="center" gap={2} minW={0}>
          <Icon as={FiEye} color="orange.700" />
          <Text fontSize="sm" color="orange.900" fontWeight="500" noOfLines={1}>
            You are viewing {fullName}'s profile as guardian
          </Text>
        </Flex>
        <Button
          size="xs"
          leftIcon={<FiX />}
          variant="outline"
          borderColor="orange.300"
          color="orange.900"
          bg="white"
          _hover={{bg: "orange.50"}}
          onClick={handleExit}
          flexShrink={0}
        >
          Back to my profile
        </Button>
      </Flex>
    </Box>
  );
}
